module.exports = __webpack_public_path__ + "media/payments/no-creditcard-e3661697.svg";